export default {"src":"/_next/static/media/room-category-all-active.acbe3ebc.svg","height":44,"width":73};